import { IDocumentFile } from 'core/components';
import { MimeType } from 'core/enums';
import { PartMediaImageType } from 'parts/enums';
import { IPartMediaDocument, IPartMediaImage } from 'parts/types';

export const YOUTUBE_URL_REGEX = new RegExp(
  '^https?:\\/\\/(?:www\\.)?youtube\\.com\\/' +
    '(?:v\\/[\\w-]+|watch\\?(?:[\\w=&-]*&)*v=[\\w-]+|embed\\/[\\w-]+)'
);

const FILENAME_MIME_MAP: Record<string, MimeType> = {
  csv: MimeType.CSV,
  gif: MimeType.GIF,
  jpeg: MimeType.JPEG,
  jpg: MimeType.JPEG,
  pdf: MimeType.PDF,
  png: MimeType.PNG,
  svg: MimeType.SVG,
  xls: MimeType.XLS,
  xlsx: MimeType.XLSX,
};

export const getMimeFromName = (name?: string, fallback?: MimeType): MimeType | undefined => {
  if (!name) {
    return fallback;
  }
  const ext = name.split('.').pop()?.toLowerCase();

  return (ext && FILENAME_MIME_MAP[ext]) || fallback;
};

export const isUploadedImage = (image: IPartMediaImage) =>
  image.type === PartMediaImageType.UPLOADED;

export const getDocumentName = (document: IPartMediaDocument): string =>
  document.name || document.fileName || '';

export const imageToDocumentFile = (image: IPartMediaImage): IDocumentFile | null => {
  if (!image.fileId && !image.url) {
    return null;
  }

  const fileMime =
    (image.mime as MimeType) || getMimeFromName(image.name, MimeType.JPEG) || MimeType.JPEG;

  return {
    id: image.fileId || image.id,
    fileId: image.fileId || undefined,
    fileFullPath: image.url,
    fileMime,
    fileName: image.name || '',
    fileSize: image.size ?? 0,
    fileUploadedAt: image.uploadDate ?? '',
    description: image.description,
  };
};

export const documentToDocumentFile = (document: IPartMediaDocument): IDocumentFile | null => {
  if (!document.fileId && !document.fullPath) {
    return null;
  }

  const fileMime =
    (document.mime as MimeType) ||
    getMimeFromName(getDocumentName(document), MimeType.PDF) ||
    MimeType.PDF;

  return {
    id: document.fileId || document.id,
    fileId: document.fileId || undefined,
    fileFullPath: document.fullPath,
    fileMime,
    fileName: getDocumentName(document),
    fileSize: document.size ?? 0,
    fileUploadedAt: document.uploadDate ?? '',
    description: document.description,
  };
};
